import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getMantencionesByMarcaModelo } from '../../helpers/api_helper';

const useMantenciones = (marca, modelo) => {
    const [mantenciones, setMantenciones] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchMantenciones = async () => {
            // Solo consultar si tenemos marca y modelo
            if (!marca || !modelo || !tenantId || !empresa) {
                setMantenciones([]);
                return;
            }

            setLoading(true);
            setError(null);
            try {
                const response = await getMantencionesByMarcaModelo({
                    tenantId,
                    empresa,
                    marca,
                    modelo
                });

                if (response.success && Array.isArray(response.data)) {
                    setMantenciones(response.data);
                } else {
                    setMantenciones([]);
                }
            } catch (err) {
                setError(`Error al cargar mantenciones: ${err.message}`);
                setMantenciones([]);
            } finally {
                setLoading(false);
            }
        };

        fetchMantenciones();
    }, [marca, modelo, tenantId, empresa]);

    return { mantenciones, loading, error };
};

export default useMantenciones;
